import { constants, mediaQueryStyles } from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs } = breakpoints.BreakpointNames;

export const previewModeLogoCss = {
  flex: "auto",
  [mediaQuery.upTo(xs)]: {
    alignSelf: "flex-start",
  },
};

export const previewModeBodyCss = {
  flex: "auto",
  fontWeight: "400",
  letterSpacing: "normal",
  lineHeight: "150%",
};

export const previewModeActionButtonCss = {
  flex: "auto",
  [mediaQuery.upTo(xs)]: {
    alignSelf: "flex-start",
  },
};
